// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audio-item[data-v-38c14cab] {\n  max-width: 100%;\n  width: 100%;\n}\n.audio-item .audio-label[data-v-38c14cab] {\n  color: #586174;\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
